import { restClient } from '../client';


export type GetAvailabilitySlotsForRangeInput = {
  datetime_from: string;
  datetime_to: string;
  provider_id: string;
  patient_id?: string;
  exclude_providers?: string[];
};


export type GetAvailabilitySlotsForRangeOutput = {
  datetime_from: string;
  datetime_to: string;
  slots: string[];
};


export const getAvailabilitySlotsForRange = restClient.createRequest<GetAvailabilitySlotsForRangeInput, GetAvailabilitySlotsForRangeOutput>({
  url: '/api/v1/availability/slots-for-range',
  method: 'POST',
});
